module.exports = __webpack_public_path__ + "img/blue_095.3e4d9a2a.png";